/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Content_Note_CnaInputs */

const en_content_note_cna = /** @type {(inputs: Content_Note_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`- During your Plus membership, all Plus Seasonal Content is available for free use (but not permanently unlocked).
- Plus exclusive trees cannot be purchased during the season. They are only available for free use to Plus users.
- Plus-exclusive trees can be used in the “Plant Together” mode.`)
};

const ar_content_note_cna = /** @type {(inputs: Content_Note_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`- During your Plus membership, all Plus Seasonal Content is available for free use (but not permanently unlocked).
- Plus exclusive trees cannot be purchased during the season. They are only available for free use to Plus users.
- Plus-exclusive trees can be used in the “Plant Together” mode.`)
};

const de_content_note_cna = /** @type {(inputs: Content_Note_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`- During your Plus membership, all Plus Seasonal Content is available for free use (but not permanently unlocked).
- Plus exclusive trees cannot be purchased during the season. They are only available for free use to Plus users.
- Plus-exclusive trees can be used in the “Plant Together” mode.`)
};

const es_content_note_cna = /** @type {(inputs: Content_Note_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`- During your Plus membership, all Plus Seasonal Content is available for free use (but not permanently unlocked).
- Plus exclusive trees cannot be purchased during the season. They are only available for free use to Plus users.
- Plus-exclusive trees can be used in the “Plant Together” mode.`)
};

const fr_content_note_cna = /** @type {(inputs: Content_Note_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`- During your Plus membership, all Plus Seasonal Content is available for free use (but not permanently unlocked).
- Plus exclusive trees cannot be purchased during the season. They are only available for free use to Plus users.
- Plus-exclusive trees can be used in the “Plant Together” mode.`)
};

const it_content_note_cna = /** @type {(inputs: Content_Note_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`- During your Plus membership, all Plus Seasonal Content is available for free use (but not permanently unlocked).
- Plus exclusive trees cannot be purchased during the season. They are only available for free use to Plus users.
- Plus-exclusive trees can be used in the “Plant Together” mode.`)
};

const ja_content_note_cna = /** @type {(inputs: Content_Note_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`- During your Plus membership, all Plus Seasonal Content is available for free use (but not permanently unlocked).
- Plus exclusive trees cannot be purchased during the season. They are only available for free use to Plus users.
- Plus-exclusive trees can be used in the “Plant Together” mode.`)
};

const ko_content_note_cna = /** @type {(inputs: Content_Note_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`- During your Plus membership, all Plus Seasonal Content is available for free use (but not permanently unlocked).
- Plus exclusive trees cannot be purchased during the season. They are only available for free use to Plus users.
- Plus-exclusive trees can be used in the “Plant Together” mode.`)
};

const pt_br_content_note_cna = /** @type {(inputs: Content_Note_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`- During your Plus membership, all Plus Seasonal Content is available for free use (but not permanently unlocked).
- Plus exclusive trees cannot be purchased during the season. They are only available for free use to Plus users.
- Plus-exclusive trees can be used in the “Plant Together” mode.`)
};

const ru_content_note_cna = /** @type {(inputs: Content_Note_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`- During your Plus membership, all Plus Seasonal Content is available for free use (but not permanently unlocked).
- Plus exclusive trees cannot be purchased during the season. They are only available for free use to Plus users.
- Plus-exclusive trees can be used in the “Plant Together” mode.`)
};

const th_content_note_cna = /** @type {(inputs: Content_Note_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`- During your Plus membership, all Plus Seasonal Content is available for free use (but not permanently unlocked).
- Plus exclusive trees cannot be purchased during the season. They are only available for free use to Plus users.
- Plus-exclusive trees can be used in the “Plant Together” mode.`)
};

const tr_content_note_cna = /** @type {(inputs: Content_Note_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`- During your Plus membership, all Plus Seasonal Content is available for free use (but not permanently unlocked).
- Plus exclusive trees cannot be purchased during the season. They are only available for free use to Plus users.
- Plus-exclusive trees can be used in the “Plant Together” mode.`)
};

const zh_cn_content_note_cna = /** @type {(inputs: Content_Note_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`- Plus 会员开通期间，可免费使用所有季度内容（非永久解锁）
- Plus 独享树种在当季无法单独购买，仅供 Plus 会员免费使用
- Plus 独享树种可用于「一起种」模式`)
};

const zh_tw_content_note_cna = /** @type {(inputs: Content_Note_CnaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`- Plus 会员开通期间，可免费使用所有季度内容（非永久解锁）
- Plus 独享树种在当季无法单独购买，仅供 Plus 会员免费使用
- Plus 独享树种可用于「一起种」模式`)
};

/**
* | output |
* | --- |
* | "- During your Plus membership, all Plus Seasonal Content is available for free use (but not permanently unlocked). - Plus exclusive trees cannot be purchased..." |
*
* @param {Content_Note_CnaInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const content_note_cna = /** @type {((inputs?: Content_Note_CnaInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Content_Note_CnaInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_content_note_cna(inputs)
	if (locale === "ar") return ar_content_note_cna(inputs)
	if (locale === "de") return de_content_note_cna(inputs)
	if (locale === "es") return es_content_note_cna(inputs)
	if (locale === "fr") return fr_content_note_cna(inputs)
	if (locale === "it") return it_content_note_cna(inputs)
	if (locale === "ja") return ja_content_note_cna(inputs)
	if (locale === "ko") return ko_content_note_cna(inputs)
	if (locale === "pt_br") return pt_br_content_note_cna(inputs)
	if (locale === "ru") return ru_content_note_cna(inputs)
	if (locale === "th") return th_content_note_cna(inputs)
	if (locale === "tr") return tr_content_note_cna(inputs)
	if (locale === "zh_cn") return zh_cn_content_note_cna(inputs)
	return zh_tw_content_note_cna(inputs)
});